// import React, { useContext, useEffect, useState } from "react";
// import Function from "../../../StateContext/Application";
// import { Form } from "react-router-dom";
// import CreateEmployee from "../Create Employee/CreateEmployee";
// import { EditBlueBlue32, Email32, PhoneNumber32 } from "../../../../../public/LoginImages/importimages";

// const EditViewEmp = () => {
//   const types = useContext(Function);
//   const { EmployeeManagement, Roles, DepartmentHandler } = types;
//   const [Employees, SetEmployees] = useState([]);
//   const [Search, SetSearch] = useState(null);
//   const [searchdata, SetSearchData] = useState([]);
//   const [Role, SetRole] = useState([]);
//   const [DepartmentList, SetDepartment] = useState([]);
//   var [form, setForm] = useState({
//     type: "Edit",
//     FullName: "",
//     PhoneNumber: "",
//     Email: "",
//     Password: "",
//     RoleID: "",
//     Role: "",
//     Department_ID: "",
//     Department_Name: "",
//   });
//   useEffect(() => {
//     GetData();
//   }, []);
//   const handleChange = (e) => {
//     try {
//       if (e.target.id === "Department_Name") {
//         let obj = JSON.parse(e.target.value);
//         form.Department_Name = obj.Department_Name;
//         form.Department_ID = obj.Department_ID;
//       } else if (e.target.id === "Role") {
//         let obj = JSON.parse(e.target.value);
//         form.Role = obj.Designation;
//         form.RoleID = obj.RoleID;
//       } else {
//         const { name, value } = e.target;
//         setForm({ ...form, [name]: value });
//       }
//     } catch (error) {
//       console.error('Error handling change:', error);
//     }
//   };
//   async function GetData() {
//     try {
//       let data = await EmployeeManagement("View", Search);
//       let data1 = await Roles("View", null);
//       let department = await DepartmentHandler("view", null, null);
//       SetDepartment(department);
//       SetRole(data1);
//       SetEmployees(data);
//       SetSearchData(data);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   }

//   function Display_Option(id) {
//     try {
//       let data = document.getElementById(id);

//       if (data.style.display === "none") {
//         data.style.display = "block";
//       } else {
//         data.style.display = "none";
//       }
//     } catch (error) {
//       console.error('Error displaying option:', error);
//     }
//   }

//   function Editing_Options(emp) {
//     try {
//       setForm(emp);
//     } catch (error) {
//       console.error('Error setting form:', error);
//     }
//   }

//   const SearchEmployee = (e) => {
//     try {
//       let searchValue = e.target.value.toLowerCase();

//       if (!searchValue) {
//         SetEmployees(searchdata);
//         return;
//       }

//       let newData = searchdata.filter((item) => {
//         return (
//           item.FullName.toLowerCase().includes(searchValue) ||
//           item.PhoneNumber.toLowerCase().includes(searchValue) ||
//           item.Email.toLowerCase().includes(searchValue) ||
//           item.Password.toLowerCase().includes(searchValue) ||
//           item.RoleID.toString().toLowerCase().includes(searchValue) ||
//           item.Role.toLowerCase().includes(searchValue) ||
//           item.Department_ID.toString().toLowerCase().includes(searchValue) ||
//           item.Department_Name.toLowerCase().includes(searchValue)
//         );
//       });
//       console.log(newData);
//       SetEmployees(newData);
//     } catch (error) {
//       console.error('Error searching employees:', error);
//     }
//   };

//   async function SubmitEdit() {
//     try {
//       let b = await EmployeeManagement("Update", form);
//     } catch (error) {
//       console.error('Error submitting edit:', error);
//     }
//   }

//   return (
//     <div className="container" style={{ padding: '20px', backgroundColor: '#f4f7fe', maxHeight: '94vh', overflowY: 'auto' }}>
//       <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
//         {/* <div style={{ marginTop: 20, display: 'grid', width: '70vw', border: 'none', padding: '30px', backgroundColor: '#d1d4ff', borderRadius: '10px', flexWrap: "wrap", }}>
//           <button style={{ display: 'flex', justifyContent: 'start', fontSize: '16px', color: 'black' }}
//             onClick={(e) => Display_Option("create_Employee")}
//           >
//             {" "}
//             Create Employee
//           </button>
//           <div id="create_Employee" style={{ display: "none" }}>
//             <CreateEmployee></CreateEmployee>
//           </div>

//           <Form onSubmit={GetData}>
//             <div className="row mt-3">
//               <div className="col-md-12">
//                 <span style={{ display: "flex", justifyContent: "center" }}>
//                   <input
//                     className="form-control"
//                     type="search"
//                     placeholder="Search Employees by Full Name/Email ID/Role ID"
//                     onChange={(e) => {
//                       SearchEmployee(e);
//                     }}
//                   />
//                 </span>
//               </div>
//             </div>
//           </Form>
//         </div> */}
//       </div>
//       <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 10px", borderRadius: "20px", width: "78vw", maxWidth: "100%", }}>
//         <div style={{
//           backgroundColor: "white",
//           borderRadius: "20px",
//           padding: "20px",
//           overflowX: "auto",
//           width: "100%",
//         }}>
//           <form style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
//             gap: "20px"
//           }}>
//             {Employees && Employees.map((emp, index) => (
//               <div key={index}
//                 style={{
//                   border: "1px solid #e0e0e0",
//                   borderRadius: "15px",
//                   padding: "20px",
//                   boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
//                 }}>

//                 <h3 style={{
//                   fontSize: "18px",
//                   fontWeight: "700",
//                   color: "#075ef8",
//                   marginBottom: "15px",
//                   textAlign: "center"
//                 }}>
//                   Employee {index + 1}
//                 </h3>

//                 {/* Full Name */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>Full Name</label>
//                   <input
//                     type="text"
//                     value={emp.FullName}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       fontWeight: "600",
//                       color: "#8eb4d5"
//                     }}
//                   />
//                 </div>

//                 {/* Phone Number */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>
//                     <img src={PhoneNumber32} style={{ width: "17px", marginRight: "5px" }} />
//                     Phone Number
//                   </label>
//                   <input
//                     type="text"
//                     value={emp.PhoneNumber}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#8a8b8c",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Email */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>
//                     <img src={Email32} style={{ width: "17px", marginRight: "5px" }} />
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     value={emp.Email}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#075ef8",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Password */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>Password</label>
//                   <input
//                     type="text"
//                     value={emp.Password}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#a28888",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Role ID */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>Role ID</label>
//                   <input
//                     type="text"
//                     value={emp.RoleID}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#b8b8b8",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Role */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>Role</label>
//                   <input
//                     type="text"
//                     value={emp.Role}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#766e6e",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Department ID */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>Department ID</label>
//                   <input
//                     type="text"
//                     value={emp.Department_ID}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#766e6e",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Department Name */}
//                 <div style={{ marginBottom: "10px" }}>
//                   <label style={{ fontWeight: "600" }}>Department Name</label>
//                   <input
//                     type="text"
//                     value={emp.Department_Name}
//                     readOnly
//                     style={{
//                       width: "100%",
//                       border: "1px solid #ccc",
//                       borderRadius: "8px",
//                       padding: "8px",
//                       color: "#766e6e",
//                       fontWeight: "600"
//                     }}
//                   />
//                 </div>

//                 {/* Action Button */}
//                 <div style={{ textAlign: "center", marginTop: "15px" }}>
//                   <button
//                     type="button"
//                     onClick={() => {
//                       Editing_Options(emp);
//                       Display_Option("edit_emp");
//                     }}
//                     style={{
//                       width: "6rem",
//                       border: "1px solid #502eff",
//                       backgroundColor: "white",
//                       borderRadius: "8px",
//                       color: "#502eff",
//                       fontWeight: "700",
//                       fontSize: "14px",
//                       padding: "8px",
//                       cursor: "pointer"
//                     }}
//                   >
//                     <img src={EditBlueBlue32} style={{ width: "1.3rem", verticalAlign: "middle" }} /> Edit
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </form>
//         </div>

//         {/* //Editing Form */}
//         <div
//           className="container my-5"
//           id="edit_emp"
//           style={{ display: "none" }}
//         >
//           <div className="card p-4">
//             <h2 className="card-title text-center">Edit/View Employee</h2>
//             <Form onSubmit={SubmitEdit}>
//               <div className="mb-3">
//                 <label className="form-label">Full Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="FullName"
//                   value={form.FullName}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter Full Name Here"
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label" hidden>
//                   Profile Picture
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="ProfilePic"
//                   value={form.ProfilePic}
//                   onChange={handleChange}
//                   hidden
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Phone Number</label>
//                 <input
//                   type="tel"
//                   pattern="\d{10}"
//                   minLength="10"
//                   maxLength="10"
//                   className="form-control"
//                   name="PhoneNumber"
//                   value={form.PhoneNumber}
//                   onChange={handleChange}
//                   onInput={(e) => {
//                     let enteredValue = e.target.value;
//                     enteredValue = enteredValue.slice(0, 10).replace(/\D/g, "");
//                     e.target.value = enteredValue;
//                   }}
//                   placeholder="Enter Phone Number Here"
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Email</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   name="Email"
//                   value={form.Email}
//                   onChange={handleChange}
//                   placeholder="Enter Email Here"
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   name="Password"
//                   value={form.Password}
//                   onChange={handleChange}
//                   placeholder="Enter Password Here"
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Select Department</label>

//                 <select
//                   className="form-control"
//                   id="Department_Name"
//                   onChange={(e) => handleChange(e)}
//                 >
//                   <option value={form.Department_ID}>
//                     {form.Department_Name}
//                   </option>
//                   {DepartmentList.map((e) => {
//                     return (
//                       <option key={e.Department_ID} value={JSON.stringify(e)}>
//                         {e.Department_Name}
//                       </option>
//                     );
//                   })}
//                 </select>
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Role</label>

//                 <select
//                   className="form-control"
//                   id="Role"
//                   onChange={(e) => handleChange(e)}
//                 >
//                   <option value={form.RoleID}>{form.Role}</option>
//                   {Role.map((e) => {
//                     return (
//                       <option key={e.RoleID} value={JSON.stringify(e)}>
//                         {e.Designation}
//                       </option>
//                     );
//                   })}
//                 </select>
//               </div>

//               <button type="submit" className="btn btn-primary">
//                 Submit
//               </button>
//             </Form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditViewEmp;
import React, { useContext, useEffect, useState } from "react";
import Function from "../../../StateContext/Application";
import { Form } from "react-router-dom";
import { EditBlueBlue32, Email32, PhoneNumber32 } from "../../../../../public/LoginImages/importimages";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
const EditViewEmp = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const types = useContext(Function);
  const { EmployeeManagement, Roles, DepartmentHandler } = types;

  const [Employees, SetEmployees] = useState([]);
  const [searchdata, SetSearchData] = useState([]);
  const [Role, SetRole] = useState([]);
  const [DepartmentList, SetDepartment] = useState([]);
  const [form, setForm] = useState({
    type: "Edit",
    FullName: "",
    PhoneNumber: "",
    Email: "",
    Password: "",
    RoleID: "",
    Role: "",
    Department_ID: "",
    Department_Name: "",
  });

  // Track which view is visible
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    GetData();
  }, []);

  async function GetData() {
    try {
      let data = await EmployeeManagement("View", null);
      let data1 = await Roles("View", null);
      let department = await DepartmentHandler("view", null, null);
      SetDepartment(department);
      SetRole(data1);
      SetEmployees(data);
      SetSearchData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  function Editing_Options(emp) {
    try {
      setForm(emp);
      setIsEditing(true); // switch to edit mode
    } catch (error) {
      console.error("Error setting form:", error);
    }
  }

  function handleCancelEdit() {
    setIsEditing(false); // switch back to view mode
  }

  const handleChange = (e) => {
    try {
      if (e.target.id === "Department_Name") {
        let obj = JSON.parse(e.target.value);
        setForm({ ...form, Department_Name: obj.Department_Name, Department_ID: obj.Department_ID });
      } else if (e.target.id === "Role") {
        let obj = JSON.parse(e.target.value);
        setForm({ ...form, Role: obj.Designation, RoleID: obj.RoleID });
      } else {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
      }
    } catch (error) {
      console.error("Error handling change:", error);
    }
  };

  async function SubmitEdit(e) {
    e.preventDefault();
    try {
      const data = await EmployeeManagement("Update", form);
      console.log(data);
      if(data == true){ 
        alert("Updated Successfully,Please Login Again");
        localStorage.clear();
        window.location.href = "/";
      }
      
      setIsEditing(false); // go back to view after update
      await GetData(); // refresh list
    } catch (error) {
      console.error("Error submitting edit:", error);
    }
  }

  // return (
  //   <div className="container" style={{ padding: "20px", backgroundColor: "#f4f7fe", maxHeight: "94vh", overflowY: "auto" }}>
  //     <div style={{ display: "flex", justifyContent: "center" }}>
  //       <div
  //         style={{
  //           display: !isEditing ? "grid" : "none", // Hide view list when editing
  //           justifyContent: "center",
  //           boxShadow: "0px 0px 10px",
  //           borderRadius: "20px",
  //           width: "78vw",
  //           maxWidth: "100%",
  //         }}
  //       >
  //         <div
  //           style={{
  //             backgroundColor: "white",
  //             borderRadius: "20px",
  //             padding: "20px",
  //             overflowX: "auto",
  //             width: "100%",
  //           }}
  //         >
  //           <form
  //             style={{
  //               display: "grid",
  //               gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
  //               gap: "20px",
  //             }}
  //           >
  //             {Employees &&
  //               Employees.map((emp, index) => (
  //                 <div
  //                   key={index}
  //                   style={{
  //                     border: "1px solid #e0e0e0",
  //                     borderRadius: "15px",
  //                     padding: "20px",
  //                     boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  //                   }}
  //                 >
  //                   <h3
  //                     style={{
  //                       fontSize: "18px",
  //                       fontWeight: "700",
  //                       color: "#075ef8",
  //                       marginBottom: "15px",
  //                       textAlign: "center",
  //                     }}
  //                   >
  //                     Employee {index + 1}
  //                   </h3>

  //                   <div style={{ marginBottom: "10px" }}>
  //                     <label style={{ fontWeight: "600" }}>Full Name</label>
  //                     <input
  //                       type="text"
  //                       value={emp.FullName}
  //                       readOnly
  //                       style={{
  //                         width: "100%",
  //                         border: "1px solid #ccc",
  //                         borderRadius: "8px",
  //                         padding: "8px",
  //                         fontWeight: "600",
  //                         color: "#8eb4d5",
  //                       }}
  //                     />
  //                   </div>

  //                   <div style={{ marginBottom: "10px" }}>
  //                     <label style={{ fontWeight: "600" }}>
  //                       <img src={PhoneNumber32} style={{ width: "17px", marginRight: "5px" }} />
  //                       Phone Number
  //                     </label>
  //                     <input
  //                       type="text"
  //                       value={emp.PhoneNumber}
  //                       readOnly
  //                       style={{
  //                         width: "100%",
  //                         border: "1px solid #ccc",
  //                         borderRadius: "8px",
  //                         padding: "8px",
  //                         color: "#8a8b8c",
  //                         fontWeight: "600",
  //                       }}
  //                     />
  //                   </div>

  //                   <div style={{ marginBottom: "10px" }}>
  //                     <label style={{ fontWeight: "600" }}>
  //                       <img src={Email32} style={{ width: "17px", marginRight: "5px" }} />
  //                       Email
  //                     </label>
  //                     <input
  //                       type="email"
  //                       value={emp.Email}
  //                       readOnly
  //                       style={{
  //                         width: "100%",
  //                         border: "1px solid #ccc",
  //                         borderRadius: "8px",
  //                         padding: "8px",
  //                         color: "#075ef8",
  //                         fontWeight: "600",
  //                       }}
  //                     />
  //                   </div>

  //                   <div style={{ marginBottom: "10px" }}>
  //                     <label style={{ fontWeight: "600" }}>Password</label>
  //                     <input
  //                       type="text"
  //                       value={emp.Password}
  //                       readOnly
  //                       style={{
  //                         width: "100%",
  //                         border: "1px solid #ccc",
  //                         borderRadius: "8px",
  //                         padding: "8px",
  //                         color: "#a28888",
  //                         fontWeight: "600",
  //                       }}
  //                     />
  //                   </div>

  //                   <div style={{ marginBottom: "10px" }}>
  //                     <label style={{ fontWeight: "600" }}>Role</label>
  //                     <input
  //                       type="text"
  //                       value={emp.Role}
  //                       readOnly
  //                       style={{
  //                         width: "100%",
  //                         border: "1px solid #ccc",
  //                         borderRadius: "8px",
  //                         padding: "8px",
  //                         color: "#766e6e",
  //                         fontWeight: "600",
  //                       }}
  //                     />
  //                   </div>

  //                   <div style={{ marginBottom: "10px" }}>
  //                     <label style={{ fontWeight: "600" }}>Department</label>
  //                     <input
  //                       type="text"
  //                       value={emp.Department_Name}
  //                       readOnly
  //                       style={{
  //                         width: "100%",
  //                         border: "1px solid #ccc",
  //                         borderRadius: "8px",
  //                         padding: "8px",
  //                         color: "#766e6e",
  //                         fontWeight: "600",
  //                       }}
  //                     />
  //                   </div>

  //                   <div style={{ textAlign: "center", marginTop: "15px" }}>
  //                     <button
  //                       type="button"
  //                       onClick={() => Editing_Options(emp)}
  //                       style={{
  //                         width: "6rem",
  //                         border: "1px solid #502eff",
  //                         backgroundColor: "white",
  //                         borderRadius: "8px",
  //                         color: "#502eff",
  //                         fontWeight: "700",
  //                         fontSize: "14px",
  //                         padding: "8px",
  //                         cursor: "pointer",
  //                       }}
  //                     >
  //                       <img src={EditBlueBlue32} style={{ width: "1.3rem", verticalAlign: "middle" }} /> Edit
  //                     </button>
  //                   </div>
  //                 </div>
  //               ))}
  //           </form>
  //         </div>
  //       </div>

  //       {/* Editable Form */}
  //       {isEditing && (
  //         <div className="container my-5" id="edit_emp">
  //           <div className="card p-4">
  //             <h2 className="card-title text-center">Edit/View Employee</h2>
  //             <Form onSubmit={SubmitEdit}>
  //               <div className="mb-3">
  //                 <label className="form-label">Full Name</label>
  //                 <input
  //                   type="text"
  //                   className="form-control"
  //                   name="FullName"
  //                   value={form.FullName}
  //                   onChange={handleChange}
  //                   required
  //                 />
  //               </div>

  //               <div className="mb-3">
  //                 <label className="form-label">Phone Number</label>
  //                 <input
  //                   type="tel"
  //                   className="form-control"
  //                   name="PhoneNumber"
  //                   value={form.PhoneNumber}
  //                   onChange={handleChange}
  //                   pattern="\d{10}"
  //                   minLength="10"
  //                   maxLength="10"
  //                 />
  //               </div>

  //               <div className="mb-3">
  //                 <label className="form-label">Email</label>
  //                 <input
  //                   type="email"
  //                   className="form-control"
  //                   name="Email"
  //                   value={form.Email}
  //                   onChange={handleChange}
  //                 />
  //               </div>

  //               <div className="mb-3">
  //                 <label className="form-label">Password</label>
  //                 <input
  //                   type="text"
  //                   className="form-control"
  //                   name="Password"
  //                   value={form.Password}
  //                   onChange={handleChange}
  //                 />
  //               </div>

  //               {/* <div className="mb-3">
  //                 <label className="form-label">Select Department</label>
  //                 <select className="form-control" id="Department_Name" onChange={handleChange}>
  //                   <option value={form.Department_ID}>{form.Department_Name}</option>
  //                   {DepartmentList.map((e) => (
  //                     <option key={e.Department_ID} value={JSON.stringify(e)}>
  //                       {e.Department_Name}
  //                     </option>
  //                   ))}
  //                 </select>
  //               </div>

  //               <div className="mb-3">
  //                 <label className="form-label">Role</label>
  //                 <select className="form-control" id="Role" onChange={handleChange}>
  //                   <option value={form.RoleID}>{form.Role}</option>
  //                   {Role.map((e) => (
  //                     <option key={e.RoleID} value={JSON.stringify(e)}>
  //                       {e.Designation}
  //                     </option>
  //                   ))}
  //                 </select>
  //               </div> */}

  //               <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
  //                 <button type="submit" className="btn btn-primary">
  //                   Submit
  //                 </button>
  //                 <button
  //                   type="button"
  //                   className="btn btn-secondary"
  //                   onClick={handleCancelEdit}
  //                 >
  //                   Cancel
  //                 </button>
  //               </div>
  //             </Form>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
  return (
    <div className="container" style={{ padding: "20px", backgroundColor: "#f4f7fe", maxHeight: "94vh", overflowY: "auto" }}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            display: !isEditing ? "grid" : "none", // Hide view list when editing
            justifyContent: "center",
            boxShadow: "0px 0px 10px",
            borderRadius: "20px",
            width: "78vw",
            maxWidth: "100%",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
              padding: "20px",
              overflowX: "auto",
              width: "100%",
            }}
          >
            <form
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gap: "20px",
              }}
            >
              {Employees &&
                Employees.map((emp, index) => (
                  <div
                    key={index}
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "15px",
                      padding: "20px",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#075ef8",
                        marginBottom: "15px",
                        textAlign: "center",
                      }}
                    >
                      {t("Employee")} {index + 1}
                    </h3>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>{t("Full Name")}</label>
                      <input
                        type="text"
                        value={emp.FullName}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "8px",
                          fontWeight: "600",
                          color: "#8eb4d5",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>
                        <img src={PhoneNumber32} style={{ width: "17px", marginRight: "5px" }} />
                        {t("Phone Number")}
                      </label>
                      <input
                        type="text"
                        value={emp.PhoneNumber}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "8px",
                          color: "#8a8b8c",
                          fontWeight: "600",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>
                        <img src={Email32} style={{ width: "17px", marginRight: "5px" }} />
                        {t("Email")}
                      </label>
                      <input
                        type="email"
                        value={emp.Email}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "8px",
                          color: "#075ef8",
                          fontWeight: "600",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>{t("Password")}</label>
                      <input
                        type="text"
                        value={emp.Password}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "8px",
                          color: "#a28888",
                          fontWeight: "600",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>{t("Role")}</label>
                      <input
                        type="text"
                        value={emp.Role}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "8px",
                          color: "#766e6e",
                          fontWeight: "600",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label style={{ fontWeight: "600" }}>{t("Department")}</label>
                      <input
                        type="text"
                        value={emp.Department_Name}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "8px",
                          color: "#766e6e",
                          fontWeight: "600",
                        }}
                      />
                    </div>

                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                      <button
                        type="button"
                        onClick={() => Editing_Options(emp)}
                        style={{
                          width: "6rem",
                          border: "1px solid #502eff",
                          backgroundColor: "white",
                          borderRadius: "8px",
                          color: "#502eff",
                          fontWeight: "700",
                          fontSize: "14px",
                          padding: "8px",
                          cursor: "pointer",
                        }}
                      >
                        <img src={EditBlueBlue32} style={{ width: "1.3rem", verticalAlign: "middle" }} /> {t("Edit")}
                      </button>
                    </div>
                  </div>
                ))}
            </form>
          </div>
        </div>

        {/* Editable Form */}
        {isEditing && (
          <div className="container my-5" id="edit_emp">
            <div className="card p-4">
              <h2 className="card-title text-center">{t("Edit/View Employee")}</h2>
              <Form onSubmit={SubmitEdit}>
                <div className="mb-3">
                  <label className="form-label">{t("Full Name")}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="FullName"
                    value={form.FullName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("Phone Number")}</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="PhoneNumber"
                    value={form.PhoneNumber}
                    onChange={handleChange}
                    pattern="\d{10}"
                    minLength="10"
                    maxLength="10"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("Email")}</label>
                  <input
                    type="email"
                    className="form-control"
                    name="Email"
                    value={form.Email}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("Password")}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="Password"
                    value={form.Password}
                    onChange={handleChange}
                  />
                </div>

                {/* <div className="mb-3">
                  <label className="form-label">Select Department</label>
                  <select className="form-control" id="Department_Name" onChange={handleChange}>
                    <option value={form.Department_ID}>{form.Department_Name}</option>
                    {DepartmentList.map((e) => (
                      <option key={e.Department_ID} value={JSON.stringify(e)}>
                        {e.Department_Name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Role</label>
                  <select className="form-control" id="Role" onChange={handleChange}>
                    <option value={form.RoleID}>{form.Role}</option>
                    {Role.map((e) => (
                      <option key={e.RoleID} value={JSON.stringify(e)}>
                        {e.Designation}
                      </option>
                    ))}
                  </select>
                </div> */}

                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <button type="submit" className="btn btn-primary">
                   {t("Submit")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancelEdit}
                  >
                    {t("Cancel")}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditViewEmp;
